import React, { useState } from "react";
import { Container, Form, Button, Row, Col, Alert } from "react-bootstrap";
import { AiOutlineMail, AiOutlinePhone, AiFillGithub } from "react-icons/ai";
import emailjs from "emailjs-com";

function Contact() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_bkk3owu",     // Replace with your EmailJS service ID
        "template_y9bt4db",    // Replace with your EmailJS template ID
        formData,
        "_zVkZsz0QbpkQ-Zcb"      // Replace with your EmailJS public key
      )
      .then(
        (result) => {
          console.log(result.text);
          setSubmitted(true);
          setError(false);
          setFormData({ name: "", email: "", message: "" });
        },
        (error) => {
          console.log(error.text);
          setSubmitted(false);
          setError(true);
        }
      );
  };

  return (
    <section
      style={{
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#8b5cf6",
        minHeight: "100vh",
        paddingTop: "60px",
        paddingBottom: "60px",
      }}
    >
      <Container style={{ backgroundColor: "rgba(0, 0, 0, 0.75)", borderRadius: "20px", padding: "40px", boxShadow: "0 0 20px rgba(0,0,0,0.5)" }}>
        <h2 className="text-center mb-4" style={{ fontWeight: "bold", fontSize: "2.5rem", color: "#8b5cf6" }}>
          📬 Let's Connect
        </h2>

        <Row className="mb-4 text-center">
          <Col md={4}>
            <AiOutlineMail size={28} />
            <p style={{ fontSize: "1.1rem" }}><strong>Email:</strong> shuklarohan388@gmail.com</p>
          </Col>
          <Col md={4}>
            <AiOutlinePhone size={28} />
            <p style={{ fontSize: "1.1rem" }}><strong>Phone:</strong> 9580849709</p>
          </Col>
          <Col md={4}>
            <AiFillGithub size={28} />
            <p style={{ fontSize: "1.1rem" }}>
              <strong>GitHub:</strong>{" "}
              <a href="https://github.com/shuklaji-coder" target="_blank" rel="noopener noreferrer" style={{ color: "#8b5cf6" }}>
                shuklaji-coder
              </a>
            </p>
          </Col>
        </Row>

        {submitted && <Alert variant="success">✅ Message sent successfully!</Alert>}
        {error && <Alert variant="danger">❌ Failed to send message. Please try again.</Alert>}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-4">
            <Form.Label style={{ color: "#8b5cf6" }}>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your name"
              required
              style={inputStyle}
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label style={{ color: "#8b5cf6" }}>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
              style={inputStyle}
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label style={{ color: "#8b5cf6" }}>Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Write your message..."
              required
              style={{ ...inputStyle, resize: "none" }}
            />
          </Form.Group>

          <div className="text-center">
            <Button
              variant="primary"
              type="submit"
              style={{
                backgroundColor: "#8b5cf6",
                borderColor: "#8b5cf6",
                padding: "10px 30px",
                fontWeight: "bold",
                fontSize: "1.1rem",
                borderRadius: "10px",
                boxShadow: "0 0 10px #dedae8ff",
              }}
            >
              Send Message
            </Button>
          </div>
        </Form>
      </Container>
    </section>
  );
}

const inputStyle = {
  backgroundColor: "#d9d4e3ff",
  color: "#ffffff",
  border: "2px solid #8b5cf6",
  borderRadius: "10px",
  padding: "12px",
  boxShadow: "0 0 6px rgba(217, 225, 233, 0.95)",
};

export default Contact;
